module.exports = __webpack_public_path__ + "static/media/vattendrag.54a98074.mp3";